enum TravelInsuranceProcessStepEnum {
  RATER = 0, // Tarificacion
  POLICY_HOLDER_FIRST = 1, // Tomador
  DOCUMENTS = 2, // Documentos
  POLICY_HOLDER_SECOND = 3, // POLICY HOLDER
  INSUREDS = 4,
  PAYMENT = 5, // MediosPago
  EMISSION = 6 // Emitida
}

export default TravelInsuranceProcessStepEnum
